import {type FC, memo, useMemo} from "react";

import {feeTypes, taxTypes, units} from "./constant";
import type {Fee} from "./types";

import {TableCell, TableRow} from "@/client/components/Table";
import TableCellEditRemoveActions from "@/client/components/Table/TableCellEditRemoveActions";

interface Props {
    fee: Fee;
    idx: number;
    currency: string;
    onEdit: (tax: Fee) => void;
    onRemove: (idx: number) => void;
}

const FeeList: FC<Props> = ({fee, idx, currency, onEdit, onRemove}) => {
    const {feeType, tax, unit} = useMemo(() => {
        return {
            feeType: feeTypes.find(elem => elem.value === fee.feeType),
            tax: taxTypes.find(elem => elem.value === fee.taxType),
            unit: units.find(elem => elem.value === fee.unit)
        };
    }, [fee]);

    return (
        <TableRow>
            <TableCell>{fee.name}</TableCell>
            <TableCell>{feeType?.label ?? "-"}</TableCell>
            <TableCell>{fee.entityType}</TableCell>
            <TableCell>{tax?.label ?? "-"}</TableCell>
            <TableCell>{unit?.label ?? "-"}</TableCell>
            <TableCell>
                {fee.valueType === "FLAT" ? `${fee.value} ${currency}` : `${fee.value}%`}
            </TableCell>
            <TableCell align="end">
                <TableCellEditRemoveActions
                    id={idx}
                    item={fee}
                    onEdit={onEdit}
                    onRemove={onRemove}
                />
            </TableCell>
        </TableRow>
    );
};

export default memo(FeeList);
